<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <div style="position: absolute;">
        <v-btn @click="$router.go(-1)" text class="pl-0">
          <v-icon class="mr-1" size="15px"> mdi-arrow-left </v-icon>
          <span class="text-return mon-regular" style="font-family: 'montserrat-medium';">{{ "Regresar" }}</span>
        </v-btn>
      </div>
      <!-- Título -->
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">
            Detalle de recargos
          </div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Facturas con recargos asignados al cedente.
          </div>
        </v-col>
      </v-row>

      <!-- Tabla Desktop -->
      <v-data-table class="d-none d-sm-block" hide-default-header :items="recargos">
        <template v-slot:header>
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">PO</th>
              <th class="header__title center">Monto Recargo</th>
              <th class="header__title center">Pagado</th>
              <th class="header__title center">Pendiente</th>
              <th class="header__title center">Fecha Recargo</th>
              <th class="header__title right">Acciones</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in recargos" :key="item.id">
              <td class="table__item">{{ item.external_invoice_id }}</td>
              <td class="table__item center">{{ formatMoney(item.total_recargo) + " USD" }}</td>
              <td class="table__item center">{{ formatMoney(item.total_pagado) + " USD" }}</td>
              <td class="table__item center">{{ formatMoney(item.pendiente) + " USD" }}</td>
              <td class="table__item center">{{ formatDate(item.fecha_recargo) }}</td>
              <td class="table__item center"><v-icon @click="verDetalle(item.chargeback_id)" class="mr-2" color="black">mdi-eye</v-icon></td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <!-- Tabla Mobile -->
      <v-data-table class="d-sm-none d-block" hide-default-header :items="recargos">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id" style="display: flex; flex-direction: column;">
              <td class="table__item__mobile"><strong>PO</strong><div>{{ item.external_invoice_id }}</div></td>
              <td class="table__item__mobile"><strong>Monto Recargo</strong><div>{{ formatMoney(item.total_recargo) + " USD" }}</div></td>
              <td class="table__item__mobile"><strong>Pagado</strong><div>{{ formatMoney(item.total_pagado) + " USD" }}</div></td>
              <td class="table__item__mobile"><strong>Pendiente</strong><div>{{ formatMoney(item.pendiente) + " USD" }}</div></td>
              <td class="table__item__mobile"><strong>Fecha Recargo</strong><div>{{ formatDate(item.fecha_recargo) }}</div></td>
              <v-divider></v-divider>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="dialogDetalle" max-width="700px">
      <v-card>
        <v-card-title class="headline" style="font-family: 'montserrat-bold'">
          Detalle del recargo
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div v-if="detalleRecargo">
            <p><strong>Factura origen:</strong> {{ detalleRecargo.factura_origen }}</p>
            <v-divider class="my-2"></v-divider>
            <p><strong>Compensaciones:</strong></p>
            <v-list dense>
              <v-list-item v-for="(comp, index) in detalleRecargo.compensaciones" :key="index">
                <v-list-item-content>
                  <v-list-item-title>
                    {{ formatMoney(comp.amount_applied) }} USD → Factura aplicada: {{ comp.factura_aplicada || '—' }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDetalle = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      recargos: [],
      dialogDetalle: false,
      detalleRecargo: null
    };
  },
  methods: {
    async getDetalle() {
      try {
        const response = await DB.get(`${URI}/api/v1/en/chargebacks/detalle/${this.$route.params.cedenteId}`, {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
          }
        });

        this.recargos = response.data.recargos.map(r => ({
          ...r,
          pendiente: r.total_recargo - r.total_pagado,
        }));
      } catch (error) {
        console.error(error);
      }
    },
    async verDetalle(recargoId) {
      this.dialogDetalle = true;
      const response = await DB.get(`${URI}/api/v1/en/chargebacks/recargo/${recargoId}/detalle`, {
        headers: { Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : "" }
      });
      this.detalleRecargo = {
        factura_origen: response.data.compensaciones?.[0]?.factura_origen || '—',
        compensaciones: response.data.compensaciones || []
      };
    },
    formatMoney(value) {
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
  },
  mounted() {
    this.getDetalle();
  }
};
</script>
